export default function useReplaceImages(replacedArticleBody) {
    return replacedArticleBody.replace(new RegExp('<img', 'ig'), '<img style="max-width: 100%; height: auto;"');
}
